import { render, staticRenderFns } from "./InstoCredit.vue?vue&type=template&id=2ad72730&scoped=true"
import script from "./InstoCredit.vue?vue&type=script&lang=js"
export * from "./InstoCredit.vue?vue&type=script&lang=js"
import style0 from "./InstoCredit.vue?vue&type=style&index=0&id=2ad72730&prod&DownloadModal=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad72730",
  null
  
)

export default component.exports